









# import settings from '@/settings'

export default {
    name: 'users_telework'

}
